/*
 If you find yourself writing the same column object multiple times, add the object here and reference it.
*/

import { TextColumn } from './text-column';

export function ID_COLUMN<T extends { id: string | number }>() {
  return new TextColumn<T>('ID', elem => elem?.id?.toString());
}
